module.exports = __webpack_public_path__ + "img/lock.f6ba8785.svg";